var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"ChildrenHorizontalLine",staticStyle:{"z-index":"2","position":"absolute","pointer-events":"none"},style:({
    left: _vm.left+'px',
    top: '102px',
    width: _vm.width+'px',
  }),attrs:{"width":"1","stroke":"black"}},[_c('line',{attrs:{"stroke-dasharray":"5, 2","x1":"0","x2":_vm.width,"y1":"0","y2":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }